export const RELATIONSHIP_TYPES = [
  { label: 'Current or former member/applicant for SAFE products or services', value: 'Current or former member/applicant for SAFE products or services', testId: 'rel1' },
  { label: 'Job applicant/employee/contract worker', value: 'Job applicant/employee/contract worker', testId: 'rel3' },
  { label: 'Contest, sweepstakes, scholarship entrants or blog/newsletter subscriber', value: 'Contest, sweepstakes, scholarship entrants or blog/newsletter subscriber', testId: 'rel4' }
]

export const ACCOUNT_TYPES = [
  { label: 'Personal Account/Loan', value: 'Personal Account/Loan', testId: 'pos1' },
  { label: 'Business Account', value: 'Business Account', testId: 'pos2' },
  { label: 'Commercial Loan', value: 'Commercial Loan', testId: 'pos3' }
]

export const REQUEST_TYPES = [
  { label: 'Do not sell my personal information', value: 'Do not sell my personal information', testId: 'req1' },
  { label: 'Do not share my personal information', value: 'Do not share my personal information', testId: 'req2' },
  { label: 'Delete my personal information', value: 'Delete my personal information', testId: 'req3' },
  { label: 'A list of categories of my personal information collected by SAFE', value: 'A list of categories of my personal information collected by SAFE', testId: 'req4' },
  { label: 'A copy of my personal information collected by SAFE', value: 'A copy of my personal information collected by SAFE', testId: 'req5' }
]

export const ON_BEHALF_OPTIONS = [
  { label: 'Yes', value: 'Yes', testId: 'aa1' },
  { label: 'No', value: 'No', testId: 'aa2' }
]